module.exports = __webpack_public_path__ + "static/grafika8@2x-da1cc2f14b9b848007ea01a480de5dc4.png";